import { injectable } from 'inversify';

import { ICountriesRepository } from '@/domain/repositories/get-countries.repository.interface';
import { Result } from '@/entities/Result';
import { countriesDtoToCountries } from '@/infrastructure/mapper/country-mapper';
import { getCountries } from '@/infrastructure/network/data/countries';
import { CountriesResponse } from '@/infrastructure/network/dto/CountryDto';

@injectable()
export class CountriesRepository implements ICountriesRepository {
	async getCountries(): Promise<Result<CountriesResponse>> {
		const result = await getCountries();
		if (result.statusCode === 200) {
			return { data: countriesDtoToCountries(result.data), statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}
}
